import { BoxGeometry, CylinderGeometry, Group, Mesh } from 'three';
import type { MailboxConfig } from '@/model/schema';
import type { MaterialKit } from '../materials';

/** Mailbox: a post with a small box head. Kept deliberately simple for v1. */
export function buildMailbox(mailbox: MailboxConfig, kit: MaterialKit): Group {
  const group = new Group();
  group.name = 'Mailbox';
  group.position.set(mailbox.x, 0, mailbox.z);

  const postRadius = 0.04;
  const postGeo = new CylinderGeometry(postRadius, postRadius, mailbox.height, 10);
  const post = new Mesh(postGeo, kit.mailbox);
  post.position.y = mailbox.height / 2;
  post.castShadow = true;
  group.add(post);

  const boxGeo = new BoxGeometry(0.32, 0.18, 0.22);
  const box = new Mesh(boxGeo, kit.mailbox);
  box.position.y = mailbox.height + 0.12;
  box.castShadow = true;
  group.add(box);

  return group;
}
